import { IInteriorDecoration } from '../../types/newbuilding/interiorDecoration';
import { IApplicationState } from '../../types/redux';

export function getInteriorDecoration(state: IApplicationState): IInteriorDecoration[] {
  const items = state.newbuilding.interiorDecoration;

  return items.filter(({ images }) => images.length);
}
